import React from 'react';
import AdSlot from './AdSlotComponent';

import Card from './ui/Card';

function Faq() {
    return (
        <Card
            className="p-6 max-w-3xl mx-auto"
            data-editorial-content="true"
        >
            <h1 className="text-2xl font-bold mb-4">FAQ - Perguntas Frequentes</h1>
            <p className="mb-4 text-slate-300">
                Respostas às dúvidas mais comuns sobre o Pleini Pouquer e o uso do Planning Poker
                para estimativas em equipes ágeis.
            </p>
            <div className="mb-4">
                <h2 className="font-semibold">✅ O que é o Pleini Pouquer?</h2>
                <p>
                    É uma aplicação gratuita de Scrum Poker (Planning Poker) para estimativas ágeis com sua equipe.
                    Não exige instalação nem cadastro: você cria uma sala, compartilha o link e começa a votar.
                </p>
            </div>
            <div className="mb-4">
                <h2 className="font-semibold">👥 Preciso criar uma conta?</h2>
                <p>
                    Não. Basta acessar o site, criar uma sala e compartilhar o ID ou o link com o time.
                    Cada participante entra com um nome e já pode votar. Ideal para reuniões remotas ou presenciais.
                </p>
            </div>
            <div className="mb-4">
                <h2 className="font-semibold">🧠 Como funciona a votação?</h2>
                <p>
                    O moderador cadastra as histórias ou tarefas. Cada participante escolhe uma carta em segredo.
                    Quando todos tiverem votado, o botão para revelar os votos é exibido. Em caso de divergência,
                    o time discute e pode votar de novo até chegar a um consenso.
                </p>
            </div>
            <div className="mb-4">
                <h2 className="font-semibold">📋 Posso cadastrar múltiplas histórias?</h2>
                <p>
                    Sim! É possível cadastrar, excluir e ativar várias histórias para votação. A sessão fica
                    organizada e o time consegue estimar um backlog inteiro em uma única reunião.
                </p>
            </div>
            <div className="mb-4">
                <h2 className="font-semibold">🔒 Meus dados são armazenados?</h2>
                <p>
                    As salas e os votos são temporários e usados apenas durante a sessão. Não guardamos
                    histórico de partidas nem dados pessoais. Consulte a página de Política de Privacidade
                    para mais detalhes.
                </p>
            </div>
            <>
                {/* Mantém o anúncio após o conteúdo, não no topo */}
                <AdSlot adSlot="7348901130475950" format="auto" />
            </>
        </Card>
    );
}

export default Faq;